/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isJSExpression(data) {
  return data && data.type === 'JSExpression' && data.extType !== 'function';
}